import { Component, inject } from '@angular/core'
import { TbIconComponent } from '@components-library/tb-icon/tb-icon.component'
import { TbTooltipComponent } from '@components-library/tb-tooltip/tb-tooltip-component/tb-tooltip.component'
import { WorkspaceFacadeService } from '@core/services/store-facade'
import { WorkspacesListComponent } from './workspaces-list/workspaces-list.component'
import { MatIconModule } from '@angular/material/icon'
import { TbMenuComponent } from '@components-library/tb-menu/tb-menu.component'
import { AsyncPipe } from '@angular/common'
import { MatMenuModule } from '@angular/material/menu'
import { Workspace } from '@core/models'

@Component({
    selector: 'app-workspace-controls',
    templateUrl: './workspace-controls.component.html',
    imports: [
        TbMenuComponent,
        MatIconModule,
        AsyncPipe,
        TbTooltipComponent,
        TbIconComponent,
        MatMenuModule,
    ],
})
export class WorkspaceControlsComponent {
    private readonly workspaceFacadeService = inject(WorkspaceFacadeService)

    menuComponent = WorkspacesListComponent

    selectedWorkspace$ = this.workspaceFacadeService.selectSelectedWorkspace$

    getWorkspaceColor(workspace: Workspace): string | null {
        return workspace.color?.value || null
    }

    getWorkspaceIcon(workspace: Workspace): string {
        return workspace.icon?.value || ''
    }

    getWorkspaceName(workspace: Workspace): string {
        return workspace.name?.value || ''
    }
}
